
import { DefaultForm as ShopDefaultForm } from "@shop/frontend/web/js/classes/form/DefaultForm";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";

export class DefaultForm extends ShopDefaultForm {
    constructor(form) {
        super(form);
        this.agreementsTouched = false;
    }

    init() {
        const form = $(this.$form);
        form.on(
            'change',
            '[name="RegistrationForm[agree]"], [name="RegistrationForm[user_agreement]"]',
            () => {
                this.agreementsTouched = true;
            }
        );

        $(form).on("afterValidate", (event, messages, errorAttributes) => {
            this.errors = [];
            if (messages) {
                Object.keys(messages).forEach(key => {
                    const keyLast = key.split("-")[1];
                    if (messages.errors) {
                        Object.keys(messages.errors).forEach(error => {
                            if (error === keyLast) {
                                this.errors.push(key);
                            }
                        });
                    } else {
                        if (messages[key].length) {
                            this.errors.push(key);
                        }
                    }
                });
                const checkboxError = $('.help-block_agreements');
                const hasAgreementError =
                    messages?.['registrationform-agree']?.length ||
                    messages?.['registrationform-user_agreement']?.length;
                if(this.agreementsTouched && hasAgreementError) {
                    checkboxError.addClass('has-error')
                    checkboxError.text(translator.t('main', 'To successfully register, you must check the boxes "I have read the User Agreement" and "I consent to the processing of personal data"'));
                } else {
                    checkboxError.removeClass('has-error')
                    checkboxError.text('');
                }
                this.checkFields(this.$form);
            }
        });
    }
}